/*   参数工厂
 --------------------------------------------------------------------------------
 作者：王哲                           创建日期：2018/03/12
 --------------------------------------------------------------------------------
 提供方法列表：
 ★对象保存
 ★对象读取
 ★根据参数guid创建对象
 ★对象删除
 --------------------------------------------------------------------------------
 修改：                               修改日期：
 修改内容:

 --------------------------------------------------------------------------------

 *******************************************************************************/

import { GUID } from '../sgiConstants/sgiCommonConstant'
import { sgiLocalStorage } from '../sgiCommon/localStorage'
import sgiConfig from '../sgiConfig/sgiConfig'


const cacheFlag = false;

/**
 * 去掉参数中的特定无用字段，默认去掉_key字段
 * @param {*} obj 
 * @param {*} keyCode 
 * @author hanzb 2018年11月13日
 * @private
 */
const _keyFilter = function (obj, keyCode) {
	if (!obj) return;
	keyCode = keyCode || "_key";
	delete obj[keyCode];
	let cldSet = obj.cldSet;
	if (cldSet && cldSet.length > 0) {
		cldSet.forEach(cld => {
			delete cld[keyCode];
			_keyFilter(cld, keyCode);
		});
	}
}

/**
 * 参数工厂操作方法
 * @namespace 参数工厂方法集
 */
let SAPrmFactory = {

	/**
	 * 获取参数
	 *  @param {string} guid 参数唯一key
	 *  @param {boolean} [fromserver=false]	(暂不可用)强制从服务端获取参数标志，true表示强制从服务端获取
	 *  @return {object} 返回参数
	 */
	getPrm: function (guid) {
		console.log('getPrm', guid)
		if (!guid) {
			return null;
		}
		if(guid.includes('zblLink') || guid.includes('scfLink')) {
			console.log('includes', guid)
			let url = ''
			let configUrl = {
				zblLink: window.sgiSrvUrl.zblLink,
				scfLink: window.sgiSrvUrl.scfLink
			}
			// http://localhost:3100/tokenLogin?loginToken=eyJ0eXAkvGMY&info=%7B%22isMybl%22:%201,%20%22path%22:%20%22/system/user%22,%20%22page%22:%201%7D

			const routerLink = guid.substring(7);
			// /tokenLogin?info=%7B%22isMybl%22:%201,%20%22path%22:%20%22/system/user%22,%20%22page%22:%201%7D
			// url = guid.includes('zblLink') ? configUrl.zblLink : configUrl.scfLink + routerLink  + tool.getCookie('token');

			let token = tool.getCookie('token')
			if(guid.includes('zblLink')) {
				console.log('zblLink token: ' + token + 'window.sgiSrvUrl: ' + window.sgiSrvUrl);
				url = window.sgiSrvUrl.zblLink + routerLink +'?token=' + token;
			} 
			if(guid.includes('scfLink')) {
				let ssoToken = tool.getCookie('ssoToken')
				console.log('scfLink ssoToken: ' + ssoToken + 'window.sgiSrvUrl: ' + window.sgiSrvUrl);
				// token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJleHAiOjE3MTMwOTg3NDksInVzZXJuYW1lIjoiYWRtaW4ifQ.k0nwBJx98twZ0oNWzo3y9m_xw78u8B91d8lJqzdThuE'
				url = window.sgiSrvUrl.scfLink + routerLink +'&loginToken=' + ssoToken +'&myblToken=' + token;
			}

			window.open(url);
			// window.location.href = url;
			return;
		}
		if (typeof guid != 'string' || guid.constructor != String) {
			return null;
		}
		var ms = guid.split("`");
		var mguid = ms[0];
		// var res = sgiPfClient.restcall(sgiConfig.sapf + "/pf/" + mguid, "GET");
		var res = commonClient.simplecall(sgiConfig.sapf + "/params/guid/" + mguid, undefined, undefined, undefined, "GET");
		if (res && res.head && res.head.code == "0000") {
			var json = res.body;
			var length = ms.length;
			for (var i = 1; i < length; i++) {
				json = this.findMenber(json, ms[i]);
			}
			return json;
		} else {
			console.log("查询失败！", res.head ? res.head.msg : null);
			tool.popMessage(res.head.msg, "error");
			return null;
		}

	},
	/**
	 * 保存参数方法
	 *  @param {object} root 需要保存的参数对象
	 *  @return {number} 0-成功，-1-失败
	 */
	save: function (root) {
		if (!root) {
			return null;
		}
		if (!root && typeof root !== "object") {
			return null;
		}
		var guid = this.makeGUID(root);
		root.guid = guid;//参数赋值/重写guid  hanzb 2018-5-11

		// var data = {};
		let copyRoot = tool.copy(root, true);
		// 去掉_key属性
		_keyFilter(copyRoot);
		// data.root = sgiCommon.jsonToStr(copyRoot);
		// var res = sgiPfClient.restcall( + guid, "POST", data);
		commonClient.simplecall(sgiConfig.sapf + "/prm/save", copyRoot, callback);
		function callback(res) {
			if (res && res.head && res.head.code == "0000") {
				if (res.body) {
					var newprm = res.body;
					delete newprm.cldSet; //提出子节点 子节点比较重要 不能复制
				}
				// root.prmVsn = newprm.prmVsn;
				// root.auth = newprm.auth;
				// root.crtTm = newprm.crtTm;
				// root.edAuth = newprm.edAuth;
				// root.edTm = newprm.edTm;
				// root.updNum = newprm.updNum;
				Object.assign(root, newprm);
			} else {
				root = null;
				console.log("保存失败！", res.head ? res.head.msg : null);
				tool.popMessage(res.head.msg, "error");
			}
			// return root;
		}
		return root;

	},
	/**
	 * 获取指定系统下的参数
	 * @param {string} ap 
	 * @param {string} [tt] 
	 * @param {string} [ss] 
	 * @returns {object[]} 返回符合条件的参数数组
	 */
	getPrmById: function (ap, id) {
		if (!id || !ap) {
			return null;
		}
		let commonVo = { values: { ap, id } }
		let prms = {};
		commonClient.simplecall(sgiConfig.sapf + "/params/id", commonVo, function callback(res) {
			if (res && res.head && res.head.code == "0000") {
				prms = res.body;
			} else {
				console.log("查询失败", res.head ? res.head.msg : null);
				tool.popMessage(res.head.msg, "error");
			}
		});
		return prms;
	},
	/**
	 * 获取指定系统下的参数
	 * @param {string} ap 
	 * @param {string} [tt] 
	 * @param {string} [ss] 
	 * @returns {object[]} 返回符合条件的参数数组
	 */
	getPrmByAP: function (ap, batch) {
		if (!ap) {
			return null;
		}
		let prms = [];
		commonClient.simplecall(sgiConfig.sapf + "/prm/list", { values: { ap }, batch }, function callback(res) {
			if (res && res.head && res.head.code == "0000") {
				prms = res.body;
			} else {
				console.log("查询失败", res.head ? res.head.msg : null);
				tool.popMessage(res.head.msg, "error");
			}
		});
		return prms;
	},
	/**
		* 获取指定系统下的参数
		* @param {string} ap 
		* @param {string} [tt] 
		* @returns {object[]} 返回符合条件的参数数组
		*/
	getPrmByTT: function (ap, tt, batch) {
		if (!ap && !tt) {
			return null;
		}
		let prms = [];
		commonClient.simplecall(sgiConfig.sapf + "/prm/list", { values: { ap, tt }, batch }, callback);
		function callback(res) {
			if (res && res.head && res.head.code == "0000") {
				prms = res.body;
			} else {
				console.log("查询失败", res.head ? res.head.msg : null);
				tool.popMessage(res.head.msg, "error");
			}
		}
		return prms;

	},
	/**
	 * 获取指定系统下的参数
	 * @param {string} ap 
	 * @param {string} [tt] 
	 * @param {string} [ss] 
	 * @returns {object[]} 返回符合条件的参数数组
	 */
	getPrmBySS: function (ap, tt, ss, batch) {
		if (!ap && !tt && !ss) {
			return null;
		}
		let prms = [];
		commonClient.simplecall(sgiConfig.sapf + "/prm/list", { values: { ap, tt, ss }, batch }, callback);
		function callback(res) {
			if (res && res.head && res.head.code == "0000") {
				prms = res.body;
			} else {
				console.log("查询失败", res.head ? res.head.msg : null);
				tool.popMessage(res.head.msg, "error");
			}
		}
		return prms;
	},


	/**
	* 获取指定系统下的参数
	* @param {string} ap 
	* @param {string} [tt] 
	* @returns {object[]} 返回符合条件的参数数组
	*/
	getPrmDetailByTT: function (ap, tt, batch) {
		if (!ap && !tt) {
			return null;
		}
		let prms = [];
		commonClient.simplecall(sgiConfig.sapf + "/params/cndt", { values: { ap, tt }, batch }, callback);
		function callback(res) {
			if (res && res.head && res.head.code == "0000") {
				prms = res.body;
			} else {
				console.log("查询失败", res.head ? res.head.msg : null);
				tool.popMessage(res.head.msg, "error");
			}
		}
		return prms;
	},
	/**
	 * 获取指定系统下的参数
	 * @param {string} ap 
	 * @param {string} [tt] 
	 * @param {string} [ss] 
	 * @returns {object[]} 返回符合条件的参数数组
	 */
	getPrmDetailBySS: function (ap, tt, ss, batch) {
		if (!ap && !tt && !ss) {
			return null;
		}
		let prms = [];
		commonClient.simplecall(sgiConfig.sapf + "/params/cndt", { values: { ap, tt, ss }, batch }, callback);
		function callback(res) {
			if (res && res.head && res.head.code == "0000") {
				prms = res.body;
			} else {
				console.log("查询失败", res.head ? res.head.msg : null);
				tool.popMessage(res.head.msg, "error");
			}
		}
		return prms;
	},

	/**
	 * 获取指定系统下的参数
	 * @param {string} ap 
	 * @param {string} [tt] 
	 * @param {string} [ss] 
	 * @returns {object[]} 返回符合条件的参数数组
	 */
	getPrmByTE: function (ap, tt, ss, te, batch) {
		if (!ap && !tt && !ss) {
			return null;
		}
		let prms = [];
		commonClient.simplecall(sgiConfig.sapf + "/params/cndt", { values: { ap, tt, ss, te }, batch }, callback);
		function callback(res) {
			if (res && res.head && res.head.code == "0000") {
				prms = res.body;
			} else {
				console.log("查询失败", res.head ? res.head.msg : null);
				tool.popMessage(res.head.msg, "error");
			}
		}
		return prms;
	},


	/**
	 * 根据guid删除指定参数
	 * @param {string} guid 制定guid
	 */
	remove: function (guid) {
		if (!guid) {
			return 0;
		}
		if (typeof guid != 'string' || guid.constructor != String) {
			return 0;
		}
		var ms = guid.split("`");
		var mguid = ms[0];
		let prms;
		commonClient.simplecall(sgiConfig.sapf + "/prm/del", { guid: mguid }, callback);
		function callback(res) {
			if (res && res.head && res.head.code == "0000") {
				prms = 1;
			} else {
				console.log("删除失败", res.head ? res.head.msg : null);
				tool.popMessage(res.head.msg, "error");
			}
		}
		return prms;
	},

	/**
	 * 根据guid删除指定参数
	 * @param {string} guid 制定guid
	 */
	removeById: function (ap, id) {
		if (!ap || !id) {
			return 0;
		}
		let prms;
		commonClient.simplecall(sgiConfig.sapf + "/prm/del", { ap, id }, callback);
		function callback(res) {
			if (res && res.head && res.head.code == "0000") {
				prms = 1;
			} else {
				console.log("删除失败", res.head ? res.head.msg : null);
				tool.popMessage(res.head.msg, "error");
			}
		}
		return prms;
	},

	/**
	 * 获取指定系统下的参数
	 * @param {string} ap 
	 * @param {string} [tt] 
	 * @param {string} [ss] 
	 * @returns {object[]} 返回符合条件的参数数组
	 */
	getPrmByCondt: function (commonVo) {
		if (!commonVo) {
			return null;
		}
		if (!commonVo.values || !commonVo.values.ap) {
			return null;
		}
		if (!commonVo.batch) {
			commonVo.batch = false;
		}
		let prms = [];
		commonClient.simplecall(sgiConfig.sapf + "/prm/list", commonVo, function callback(res) {
			if (res && res.head && res.head.code == "0000") {
				prms = res.body;
			} else {
				console.log("查询失败", res.head ? res.head.msg : null);
				tool.popMessage(res.head.msg, "error");
			}
		});
		return prms;
	},
	/**
	 * 获取指定系统下的参数
	 * @param {string} ap 
	 * @param {string} [tt] 
	 * @param {string} [ss] 
	 * @returns {object[]} 返回符合条件的参数数组
	 */
	getPrmDetailByCondt: function (commonVo) {
		if (!commonVo) {
			return null;
		}
		if (!commonVo.values || !commonVo.values.ap) {
			return null;
		}
		if (!commonVo.batch) {
			commonVo.batch = false;
		}
		let prms = [];
		commonClient.simplecall(sgiConfig.sapf + "/params/cndt", commonVo, function callback(res) {
			if (res && res.head && res.head.code == "0000") {
				prms = res.body;
			} else {
				console.log("查询失败", res.head ? res.head.msg : null);
				tool.popMessage(res.head.msg, "error");
			}
		});
		return prms;
	},
	/**
	 * 保存参数关联信息
	 * @param {string} paramId 
	 * @param {string} rlsParamId
	 * @param {string} rlsTyp
	 * @returns {object[]} 返回符合条件的参数数组
	 */
	saveRls: function (paramId, rlsParamId, rlsTyp) {
		if (!paramId || !rlsParamId || !rlsTyp) {
			return null;
		}
		let prms = {};
		commonClient.simplecall(sgiConfig.sapf + "/prm/rls/save",
			{ ap: tool.Global.currentAP, paramId, rlsParamId, rlsTyp }, function callback(res) {
				if (res && res.head && res.head.code == "0000") {
					prms = res.body;
				} else {
					console.log("保存失败", res.head ? res.head.msg : null);
					tool.popMessage(res.head.msg, "error");
				}
			});
		return prms;
	},

	/**
	 * 删除参数关联信息
	 * @param {string} paramId 
	 * @param {string} rlsParamId
	 * @param {string} rlsTyp
	 * @returns {object[]} 返回符合条件的参数数组
	 */
	delRls: function (paramId, rlsParamId, rlsTyp) {
		if (!paramId || !rlsParamId || !rlsTyp) {
			return null;
		}
		let prms = {};
		commonClient.simplecall(sgiConfig.sapf + "/prm/rls/delete",
			{ ap: tool.Global.currentAP, paramId, rlsParamId, rlsTyp }, function callback(res) {
				if (res && res.head && res.head.code == "0000") {
					prms = res.body;
				} else {
					console.log("删除失败", res.head ? res.head.msg : null);
					tool.popMessage(res.head.msg, "error");
				}
			});
		return prms;
	},
	/**
 * 删除参数关联信息
 * @param {string} paramId 
 * @param {string} rlsParamId
 * @param {string} rlsTyp
 * @returns {object[]} 返回符合条件的参数数组
 */
	getRlsPrms: function (paramId, rlsParamId, rlsTyp) {
		if (!paramId && !rlsParamId && !rlsTyp) {
			return null;
		}
		let commonVo = { values: { ap: tool.Global.currentAP }, batch: false };
		if (paramId) {
			commonVo.values.paramId = paramId;
		}
		if (rlsParamId) {
			commonVo.values.rlsParamId = rlsParamId;
		}
		if (rlsTyp) {
			commonVo.values.rlsTyp = rlsTyp;
		}
		let prms = [];
		commonClient.simplecall(sgiConfig.sapf + "/prm/rls/params", commonVo, function callback(res) {
			if (res && res.head && res.head.code == "0000") {
				prms = res.body;
			} else {
				console.log("删除失败", res.head ? res.head.msg : null);
				tool.popMessage(res.head.msg, "error");
			}
		});
		return prms;
	},
	/**
	 * 从本地缓存获取参数
	 * @param {string} guid 参数guid
	 * @returns {object} 返回缓存参数
	 * 
	 * @ignore
	 */
	getPrmCache: function (guid) {
		return sgiLocalStorage.get(guid);
	},
	/**
	 * 将参数缓存至本地缓存中
	 * @param {string} guid 参数guid
	 * @param {object} json 参数对象
	 * 
	 * @ignore
	 */
	saveLocal: function (guid, json) {
		sgiLocalStorage.set(guid, json);
	},
	/**
	 * 从本地缓存中删除参数
	 * @param {string} guid 参数guid
	 * 
	 * @ignore
	 */
	deleteLocal: function (guid) {
		sgiLocalStorage.remove(guid);
	},

	/**
	 * 组装guid
	 * @param {object} root 参数对象
	 * @returns {string} 返回的guid
	 * 
	 * @ignore
	 */
	makeGUID: function (root) {
		var ap, tt, ss, sc;
		ap = root.ap;
		tt = root.tt;
		ss = root.ss;
		sc = root.sc;
		if (!(ap && tt && ss && sc)) {
			return null;
		}
		var guid = ap + GUID.SP + tt + GUID.SP + ss + GUID.SP + sc;
		return guid;
	},
	/**
	 * 在参数对象子节点中寻找sc匹配的子节点对象
	 * @param {object} json 参数对象
	 * @param {string} sc sc
	 * @returns {object} 匹配的子节点参数对象
	 * 
	 * @ignore
	 */
	findMenber: function (json, sc) {
		if (!json) {
			return null;
		}
		var children = json.cldSet;
		if (!children)
			return null;
		var count = children.length;
		for (var i = 0; i < count; i++) {
			if (children[i].sc === sc) {
				json = children[i];
				break;
			}
		}
		return json;
	}


}

// 初始化
if (!window.SAPrmFactory) window.SAPrmFactory = SAPrmFactory;
// 添加方法
else Object.assign(window.SAPrmFactory, SAPrmFactory);
// 导出
let wSAPrmFactory = window.SAPrmFactory;
export { wSAPrmFactory as SAPrmFactory };
export default wSAPrmFactory;


// WEBPACK FOOTER //
// ./~/rt-sd-common/sgiFactory/SAPrmFactory.js